<div class="example-container">
  <div class="example-loading-shadee">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoadingRowResults || isLoadingSupplierResults"></mat-progress-bar>
  </div>

  <div class="example-table-container">
    <mat-form-field [class.field-with-label]="true">
      <mat-label>Kweker</mat-label>
      <input #supplierInput type="text" placeholder="Selecteer een kweker..." aria-label="Kweker" matInput
        [formControl]="control" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
          <mat-option (onSelectionChange)="supplierInput.value != undefined && onEnter($event)"
                      *ngFor="let option of filteredSuppliers | async" [value]="option">
              {{option.name}}
              <small *ngIf="!option.isNameUnique"> ({{ option.ean }})</small>
          </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-tab-group (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedIndex">
      <mat-tab label="Te behandelen">
        <ng-template matTabContent>
          <div class="pt-3">
            <app-regels-table [onlyShowArchivedRegels]="false" [version]="version"
              (onSaveEvent)="updateVersion()"></app-regels-table>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="Gearchiveerd">
        <ng-template matTabContent>
          <div class="pt-3">
            <app-regels-table [onlyShowArchivedRegels]="true" [version]="version"
              (onSaveEvent)="updateVersion()"></app-regels-table>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>